import React, { Component } from 'react';

class App extends Component {
  render() {
    return (
      <div className="App">
        Welcome! 
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js